import React, { FC, useContext, useEffect, useState } from "react";

import axios from "axios";
import { baseServiceUrl, urls } from "../../environment";
import toast from "react-hot-toast";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import CheckIcon from "@mui/icons-material/Check";
import ExamInformationSection from "./ExamInformationSection";
import useUserStore from "../../stores/useUserStores";
type SyncOfflineDashboardProps = {
  tests: Array<any>;
};
const SyncOfflineDashboard: FC<SyncOfflineDashboardProps> = ({
  tests,
}): JSX.Element => {
  const {
    token,
    setLoading,
    loading,
    setOfflineExamLineInformation,
    offlineExamInformation,
  } = useUserStore();

  return (
    <section
      id="sample-paper"
      className={` flex flex-col items-center justify-center`}
      // style={!offlineExamInformation?{filter: "blur(6px)"} : {}}
    >
      {tests.length ? (
        <div className="container w-full py-4 lg:w-[90%] md:w-[100%] mx-auto">
          <ExamInformationSection tests={tests} />
          <div className="my-6">
            {/* <DataGrid
               sx={{
                 ".MuiDataGrid-columnHeader": {
                   backgroundColor: "#E5E7EB",
                 },
                 ".MuiDataGrid-columnHeaderTitle": {
                   fontWeight: "500",
                   fontSize: 16,
                   color: "#23304a",
                 },
                 ".MuiDataGrid-cell": {
                   padding: 1,
                 },
               }}
               getRowHeight={() => "auto"}
               rows={question}
               columns={columns}
               initialState={{
                 pagination: {
                   paginationModel: { page: 0, pageSize: 5 },
                 },
               }}
               pageSizeOptions={[5, 10]}
             /> */}
          </div>
        </div>
      ) : (
        <></>
      )}
    </section>
  );
};

export default SyncOfflineDashboard;
